// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"v5-z","colorTextValue":"w5-z","swatches":"x5-z","collapseLink":"y5-z","isCollapsed":"z5-z","dropdown":"A5-z","disabled":"B5-z"};